"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = _interopRequireDefault(require("../../utils/core"));

var _jquery = _interopRequireDefault(require("jquery"));

var Footer = _core["default"].Class.extend({
  constructor: function constructor(plugin, footerOptions) {
    this.plugin = plugin;
    this.footerOptions = footerOptions;
  },
  render: function render() {
    var p = this.plugin,
        self = this,
        columns = p.getVisibleColumns(),
        $footer = (0, _jquery["default"])('<div>').addClass('footer'),
        totalWidth = 0;
    $footer.append('<table>');
    this.$tableFooter = $footer.find('table');
    var $trGridSize = (0, _jquery["default"])('<tr>').addClass('grid-size');

    _core["default"].each(columns, function (i, column) {
      totalWidth += parseInt(column.size);
      $trGridSize.append((0, _jquery["default"])('<td>').width(column.size));
    });

    var $tdLastColumn = (0, _jquery["default"])('<td>').addClass('last-column');
    $trGridSize.append($tdLastColumn);
    this.$tableFooter.append($trGridSize);

    _core["default"].each(this.footerOptions || [], function (i, record) {
      var $row = self._addRecord(record),
          $tdLastColumn = (0, _jquery["default"])('<td>').addClass('last-column');

      $row.append($tdLastColumn);
    });

    return $footer;
  },
  _addRecord: function _addRecord(record) {
    var p = this.plugin,
        columns = p.getVisibleColumns();
    var $row = (0, _jquery["default"])("<tr>").addClass(['record', record.rowClass].join(' '));
    $row.data('record', record);

    _core["default"].each(columns, function (i, column) {
      var $cell = (0, _jquery["default"])('<td>').addClass(column.hasOwnProperty('columnClass') ? column.columnClass : ''),
          $content = (0, _jquery["default"])('<div>').addClass('col-wrapper').append((0, _jquery["default"])('<div>').addClass('column-name').html(record[column.field]));
      $row.append($cell.append($content));
    });

    this.$tableFooter.append($row);
    return $row;
  },
  adjust: function adjust() {
    if (this.plugin.e.find('.grid').hasScrollBarHorizontal()) {
      var wScrollBar = _core["default"].getScrollbarWidth();

      if (wScrollBar) {
        this.plugin.e.find('.footer .last-column').css('width', wScrollBar);
      }
    } else {
      this.plugin.e.find('.footer .last-column').css('width', 'auto');
    }
  }
});

var _default = Footer;
exports["default"] = _default;